import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import { isWindowDefined } from '@core/Constants/Window';
import { clientLog } from '@core/Utils/Log/ClientLog';

import { TrackingEvent } from '../Entities/Schema.entity';

import { eventStoreTrigger } from './EventStore';
import { extractSchemaName } from './ExtractSchemaName';
import { getSchemaByRef } from './GetSchemaByRef';
import { updateLoginStatus } from './UserContextUtils';
import { validateSchema } from './ValidateSchema';

export const trackCustomEvent = ({
  event,
  context,
}: {
  event: TrackingEvent;
  context: TrackingEvent[];
}) => {
  updateLoginStatus(context, event);

  validateSchema(getSchemaByRef(event.schema), event);
  context?.map(event => validateSchema(getSchemaByRef(event.schema), event));
  trackSelfDescribingEvent({ event, context });

  const eventObject = {
    event: extractSchemaName(event.schema),
    data: event.data,
    context,
    hash: Date.now().toString(36),
  };

  // @ts-expect-error - window typing
  if (isWindowDefined) (window.dataLayer ||= []).push(eventObject);
  // @ts-expect-error - window typing
  if (isWindowDefined) (window.eventHistory ||= []).push(eventObject);

  clientLog({ data: { event, context }, label: `Event: ${event.schema}`, color: '#e6faf6' });

  eventStoreTrigger?.forceUpdate?.();
};
